<template>
  <div class="mt-2">
    <ShareNetwork
      class="social_fb"
      :network="'facebook'"
      style="backgroundcolor: #1877f2"
      :url="share_url"
      :title="shopname"
    >
      <i style="color: #fff" class="fab fah fa-lg fa-facebook-f"></i>
    </ShareNetwork>
    <ShareNetwork
      class="social_style"
      v-for="network in networks"
      :network="network.network"
      :key="network.network"
      :style="{ backgroundColor: network.color }"
      :url="share_url"
      :title="'🏬  *'+shopname.trim()+'* -'+desc"
    >

      <i style="color: #fff" :class="network.icon"></i>
    </ShareNetwork>
  </div>
</template> 
<script>
export default {
  props: ["share_url","shopname","desc"],
  data() {
    return {
      sharing: {
        url: this.share_url,
      },
      networks: [
        {
          network: "whatsapp",
          name: "Whatsapp",
          icon: "fab fah fa-lg fa-whatsapp",
          color: "#25d366",
        },
        {
          network: "twitter",
          name: "Twitter",
          icon: "fab fah fa-lg fa-twitter",
          color: "#1da1f2"
        },
      ],
    };
  },
  mounted(){
  }
};
</script>
<style >
.social_fb {
  padding-top: 10px;
  padding-bottom: 10px;
  margin: 2px;
  padding-left: 13px;
  padding-right: 13px;
  justify-content: center;
  background: #1877f2;
  text-align: center;
  border-radius: 50%;
}
.social_style {
  padding: 10px;
  /* font-size: 24px; */
  margin: 2px;
  justify-content: center;
  text-align: center;
  border-radius: 50%;
}
</style>